import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../components/Button';
import ImageShow from '../components/ImageShow';
import Link from '../components/Link';
import PanelBlock from '../components/PanelBlock';
import useBroker from '../hooks/use-broker';
import useNavigation from '../hooks/use-navigation';
import { useAutoSynchronizeMutation } from '../store';

function AutoSyncPage() {
  const { t } = useTranslation();
  const { navigate } = useNavigation();
  const [autoSynchronize, { isLoading }] = useAutoSynchronizeMutation();
  const [publicKey, setPublicKey] = useState('');
  const [privateKey, setPrivateKey] = useState('');

  let { broker } = useBroker();
  if (!broker) {
    broker = JSON.parse(localStorage.getItem('broker'));
  }

  const handleSubmit = async () => {
    const result = await autoSynchronize({ publicKey, privateKey });
    if (!result.error) {
      navigate('/accounts');
    }
  };

  return (
    <div className="page">
      <Link
        to="/accounts"
        icon="back"
        className="text-gray-350 text-sm block pb-4">
        {broker && (
          <>
            <ImageShow
              className="ml-2"
              image={{ url: broker, label: broker }}
            />
            <span className="text-md ml-2">
              {t('accounts.brokers.' + broker)}
            </span>
          </>
        )}
      </Link>
      <h1 className="text-black text-2xl pb-7">{t('components.autoSync.title')}</h1>
      <PanelBlock heading={t('components.autoSync.title')}>
        <div className="flex flex-col gap-4 max-w-[480px]">
          <input
            type="text"
            value={publicKey}
            onChange={(e) => setPublicKey(e.target.value)}
            placeholder={t('components.autoSync.publicKey')}
            className="w-full px-4 py-3 rounded-xl border border-gray-200 bg-white text-sm focus:outline-none focus:border-cyan-650"
          />
          <input
            type="text"
            value={privateKey}
            onChange={(e) => setPrivateKey(e.target.value)}
            placeholder={t('components.autoSync.privateKey')}
            className="w-full px-4 py-3 rounded-xl border border-gray-200 bg-white text-sm focus:outline-none focus:border-cyan-650"
          />
          <Button
            onClick={handleSubmit}
            disabled={isLoading || !publicKey || !privateKey}
            className="w-full h-[60px] flex justify-center border-transparent rounded-xl text-white user-select-none mt-2 from-cyan-650 to-cyan-75 hover:from-cyan-900 hover:to-cyan-650 bg-gradient-to-r disabled:opacity-50 disabled:pointer-events-none">
            {isLoading ? t('components.autoSync.loading') : t('components.autoSync.submit')}
          </Button>
        </div>
      </PanelBlock>
    </div>
  );
}

export default AutoSyncPage;
